import { match } from 'ts-pattern'

import { DocumentTypeOption } from '@documents/types'

export function getUploadHeading(documentType: DocumentTypeOption | null) {
  return match(documentType)
    .with(DocumentTypeOption.PAYSTUB_OR_W2, () => 'upload paystubs or W2s')
    .otherwise(() => 'upload documents')
}
